import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetch as axios } from '../../axios_config';

import { handleRejectedResponse } from './utils';
import { notification } from 'antd';
import { findIndex, isArray } from 'lodash';

export const GetPoListing = createAsyncThunk(
  'po/po-listing',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.OPULENT_NODE_API_URL}/po/po-listing`,
        {
          params: data
        }
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Get Po Listing', rejectWithValue);
    }
  }
);

export const GetVendorsList = createAsyncThunk(
  'po/vendors-list',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.OPULENT_NODE_API_URL}/po/vendors-list`
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Get Vendors List', rejectWithValue);
    }
  }
);

export const GetPoDetails = createAsyncThunk(
  'po/po-details',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.OPULENT_NODE_API_URL}/po/po-details/${id}`
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Get PO Details', rejectWithValue);
    }
  }
);

export const getWarehousePos = createAsyncThunk(
  'po/warehouse-pos',
  async (data, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const warehouse_id = state.auth.currentUser.warehouse_id;
      const response = await axios.get(
        `${process.env.OPULENT_NODE_API_URL}/po/warehouse-pos`,
        {
          params: { warehouse_id, ...data }
        }
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(
        err,
        'Get Warehouse PO Data',
        rejectWithValue
      );
    }
  }
);

export const getPoUsers = createAsyncThunk(
  'po/po-users',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.OPULENT_NODE_API_URL}/po/po-users`
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Get PO Users Data', rejectWithValue);
    }
  }
);

export const getWarehousePoDetails = createAsyncThunk(
  'po/warehouse-po-details',
  async (data, { rejectWithValue }) => {
    try {
      const { id } = data;
      delete data.id;
      const response = await axios.get(
        `${process.env.OPULENT_NODE_API_URL}/po/warehouse-po-details/${id}`,
        {
          params: data
        }
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(
        err,
        'Get PO Details Data',
        rejectWithValue
      );
    }
  }
);
export const GetPoItems = createAsyncThunk(
  'po/po-items/:po_id',
  async (data, { rejectWithValue }) => {
    try {
      const { id } = data || {};
      delete data.id;

      const response = await axios.get(
        `${process.env.OPULENT_NODE_API_URL}/po/po-items/${id}`,
        {
          params: data
        }
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Get PO Items', rejectWithValue);
    }
  }
);

export const ExportFilteredPoItems = createAsyncThunk(
  'po/export-filtered-po-items/:po_id',
  async (data, { rejectWithValue }) => {
    try {
      const { id } = data || {};
      delete data.id;

      const response = await axios.get(
        `${process.env.OPULENT_NODE_API_URL}/po/export-filtered-po-items/${id}`,
        {
          params: { ...data, exportAll: true }
        }
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Export Filtered PO Items', rejectWithValue);
    }
  }
);

export const GetProductsList = createAsyncThunk(
  'po/add-products-list/:po_id',
  async (data, { rejectWithValue }) => {
    try {
      const { id } = data || {};
      delete data.id;

      const response = await axios.get(
        `${process.env.OPULENT_NODE_API_URL}/po/add-products-list/${id}`,
        {
          params: data
        }
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Get Products List', rejectWithValue);
    }
  }
);

export const ConfirmPo = createAsyncThunk(
  'po/confirm-po/:po_id',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.OPULENT_NODE_API_URL}/po/confirm-po/${id}`
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Confirm Po', rejectWithValue);
    }
  }
);

export const AddPoItems = createAsyncThunk(
  'po/add-po-items/:po_id',
  async (data, { rejectWithValue }) => {
    try {
      const { id } = data || {};
      delete data.id;

      const response = await axios.post(
        `${process.env.OPULENT_NODE_API_URL}/po/add-po-items/${id}`,
        data
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Add Po Items', rejectWithValue);
    }
  }
);

export const DeletePoItem = createAsyncThunk(
  'po/po-item/:po_item_id',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${process.env.OPULENT_NODE_API_URL}/po/po-item/${id}`
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Delete Po Item', rejectWithValue);
    }
  }
);

export const DeleteBulkPoItem = createAsyncThunk(
  'po/bulk-po-item/',
  async (body, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${process.env.OPULENT_NODE_API_URL}/po/bulk-po-item/`, {
        data: body
      }
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Bulk Delete Po Item', rejectWithValue);
    }
  }
);

export const EditPoItem = createAsyncThunk(
  'po/po-item/:po_item_id',
  async (data, { rejectWithValue }) => {
    try {
      const { id } = data || {};
      delete data.id;

      const response = await axios.patch(
        `${process.env.OPULENT_NODE_API_URL}/po/po-item/${id}`,
        data
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Edit Po Item', rejectWithValue);
    }
  }
);

export const StorePoFile = createAsyncThunk(
  'po/storePoFile',
  async (body, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.OPULENT_NODE_API_URL}/po/store-purchase-orders-file`,
        body
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Uploading File', rejectWithValue);
    }
  }
);

export const StorePoSkusMapping = createAsyncThunk(
  'po/store-po-skus-mapping',
  async (body, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.OPULENT_NODE_API_URL}/po/store-po-skus-mapping`,
        body
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(
        err,
        'Upload PO Skus Mapping',
        rejectWithValue
      );
    }
  }
);

export const DeletePoSkuMapping = createAsyncThunk(
  'po/delete-map-po-and-skus',
  async (body, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${process.env.OPULENT_NODE_API_URL}/po/delete-map-po-and-skus`,
        {
          data: body
        }
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(
        err,
        'Deleting PO SKU Mapping',
        rejectWithValue
      );
    }
  }
);

export const UpdatePoItemsFile = createAsyncThunk(
  'po/update-po-items-data',
  async (body, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.OPULENT_NODE_API_URL}/po/update-po-items-data`,
        body
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(
        err,
        'Uploading Po Items File',
        rejectWithValue
      );
    }
  }
);

export const CreatePo = createAsyncThunk(
  'po/create-po',
  async (body, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.OPULENT_NODE_API_URL}/po/create-po`,
        body
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Create PO', rejectWithValue);
    }
  }
);

export const GetPoSkusList = createAsyncThunk(
  '3-layer/po-skus-list',
  async (data, { rejectWithValue }) => {
    try {
      const { saveData } = data || {};
      delete data.saveData;

      const response = await axios.get(
        `${process.env.OPULENT_NODE_API_URL}/po/po-skus-list`,
        {
          params: data
        }
      );

      return {
        ...response,
        data: { ...response?.data, saveData }
      };
    } catch (err) {
      return handleRejectedResponse(err, 'Get PO Skus List', rejectWithValue);
    }
  }
);
export const MapPoAndSkus = createAsyncThunk(
  'po/map-po-and-skus',
  async (body, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.OPULENT_NODE_API_URL}/po/map-po-and-skus`,
        body
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Map Po & Skus', rejectWithValue);
    }
  }
);
export const CreateReceiveHistory = createAsyncThunk(
  'po/create-receive-history',
  async (body, { rejectWithValue }) => {
    try {
      const { po_item_id } = body;

      delete body.po_item_id;
      const response = await axios.post(
        `${process.env.OPULENT_NODE_API_URL}/po/create-warehouse-po-history/${po_item_id}`,
        body
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(
        err,
        'Create Receive History',
        rejectWithValue
      );
    }
  }
);
export const GetWarehousePoHistory = createAsyncThunk(
  'po/warehouse-po-history/:po_item_id',
  async (data, { rejectWithValue }) => {
    try {
      const { po_item_id } = data;
      const response = await axios.get(
        `${process.env.OPULENT_NODE_API_URL}/po/warehouse-po-history/${po_item_id}`
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(
        err,
        'Get Warehouse Po History',
        rejectWithValue
      );
    }
  }
);

export const DeleteReceivedHistory = createAsyncThunk(
  'po/delete-warehouse-po-history',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${process.env.OPULENT_NODE_API_URL}/po/delete-warehouse-po-history`,
        { params: data }
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(
        err,
        'Delete Received History',
        rejectWithValue
      );
    }
  }
);

export const UpdatePo = createAsyncThunk(
  'po/update-po',
  async (body, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${process.env.OPULENT_NODE_API_URL}/po/update-po`,
        body
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Update PO', rejectWithValue);
    }
  }
);


export const BulkReceive = createAsyncThunk(
  'po/bulk-receive',
  async (data, { rejectWithValue }) => {
    try {
      const { poId } = data || {};
      console.log({
        poId
      });
      const response = await axios.post(
        `${process.env.OPULENT_NODE_API_URL}/po/bulk-receive/${poId}`);
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Bulk Receive PO', rejectWithValue);
    }
  }
);

export const ScanProduct = createAsyncThunk(
  'po/scan-product',
  async (body, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.OPULENT_NODE_API_URL}/po/scan-product`,
        body
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Scan Product', rejectWithValue);
    }
  }
);

export const DeletePo = createAsyncThunk(
  'po/delete-po/:po_id',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.OPULENT_NODE_API_URL}/po/delete-po/${id}`
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Delete PO', rejectWithValue);
    }
  }
);

export const ExportAsinData = createAsyncThunk(
  'po/get-po-asin-details',
  async ({ poId }, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${process.env.OPULENT_NODE_API_URL}/po/get-po-asin-details/${poId}`);
      return response?.data;
    }
    catch (err) {
      return handleRejectedResponse(err, 'Export Asin Data', rejectWithValue);
    }
  }
);

export const GetErroredItems = createAsyncThunk(
  '3-layer/list-errored-skus',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${process.env.OPULENT_NODE_API_URL}/wo/list-errored-skus`,
        {
          params: data
        }
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'List Errored Items', rejectWithValue);
    }
  }
);

export const getLatestFileUpload = createAsyncThunk(
  'file-uploads/latest',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${process.env.OPULENT_NODE_API_URL}/file-uploads/latest`,
        {
          params: data
        }
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Latest File Upload History', rejectWithValue);
    }
  }

);

export const markUploadAsSeen = createAsyncThunk(
  'file-uploads/mark-upload-as-seen',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${process.env.OPULENT_NODE_API_URL}/file-uploads/mark-upload-as-seen`, data);
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Close File Upload Header', rejectWithValue);
    }
  }
);

export const getAllFileUploadHistory = createAsyncThunk(
  'file-uploads/all',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${process.env.OPULENT_NODE_API_URL}/file-uploads/all`,
        {
          params: data
        }
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'File Upload History', rejectWithValue);
    }
  }
);

export const updatePOShipQuantity = createAsyncThunk(
  'update-po-sku-ship-qty', 
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.patch(`${process.env.OPULENT_NODE_API_URL}/po/update-po-ship-quantity`, data);
      return response?.data;
    } catch (error) {
      return handleRejectedResponse(error, 'Update PO Ship Quantity', rejectWithValue);
    }
  }
);

const pos = createSlice({
  name: 'pos',
  initialState: {
    pos: [],
    totalPosCount: 0,
    fetchingPos: false,
    userPoAllStatusCount: {},


    fetchingVendorsList: false,
    vendorsList: [],

    warehousePos: [],
    totalWarehousePosCount: 0,
    fetchingWarehousePos: false,
    warehousePoAllStatusCount: {},

    poUsers: [],
    fetchingPoUsers: false,

    poWarehouseDetails: [],
    totalWarehousePoDetailsCount: 0,
    totalOrderQuantity: 0,
    totalReceivedQuantity: 0,
    totalInvoiceQuantity: 0,
    totalExtendedCost: 0,
    totalPoValue: 0,
    fetchingWarehousePoDetails: false,

    fetchingPoDetails: false,
    poDetails: {},

    confirmingPo: false,

    poItems: [],
    totalPoItemsCount: 0,
    fetchingPoItems: false,

    updatingPoItem: false,
    addingPoItems: false,
    deletingPoItem: false,
    creatingPo: false,
    uploadingPoItemsFile: false,
    uploadingPoSkusMapping: false,
    mappingPoAndSkus: false,
    deletingMappingPoAndSku: false,

    fetchingPoSkusList: false,
    totalPoSkusListCount: 0,
    poSkusList: [],

    fetchingProductsList: false,
    productsList: [],
    totalSkus: 0,
    fetchingPoDetails: false,

    warehousePoHistory: [],
    fetchingWarehousePoHistory: false,

    updatePoLoading: false,
    bulkReceivingLoading: false,
    scanProductLoading: false,
    scannedProduct: {},

    createReceivingLoading: false,
    deleteReceivingLoading: false,

    deletingPo: false,

    exportingData: false,

    fetchingErroredItems: false,
    fetchingAllFileUploadHistory: false,
    fetchingLatestFileUpload: false,
    erroredItems: [],
    erroredItemsTotalCount: 0
  },
  reducers: {
    setField(state, { payload: { field, id, key, value } }) {
      const index = findIndex(state[field], (data) => data?.id === id);
      state[field][index][key] = value;
      if (key === 'order_quantity') {
        const unitCost = Number(state[field][index]['unit_cost'] || 0);
        state[field][index]['extended_cost'] = unitCost * value;
      } else if (key === 'unit_cost') {
        const unitCost = Number(state[field][index]['order_quantity'] || 0);
        state[field][index]['extended_cost'] = unitCost * value;
      }
    },
    SetPoState(state, { payload: { field, value } }) {
      state[field] = value;
    },
    softDeleteEntry(state, { payload: { field, id } }) {
      const index = findIndex(state[field], (data) => data?.id === id);
      state[field][index].deleted = value;
    },
    updateSoftDeleteStatus(state, { payload: { field, id, value } }) {
      const index = findIndex(state[field], (data) => data?.id === id);
      state[field][index].deleted = value;
    },
    clearField(state, { payload: { field } }) {
      state[field] = isArray(state[field]) ? [] : {};
    },
    updateShipQty(state, { payload: { field, parentIndex, childIndex, value } }) {
      state[field][parentIndex]['seller_skus'][childIndex]['ship_quantity'] = value;
    },
    updatePOShipQty(state, { payload: { field, parentIndex, childIndex, value } }) {
      const sellerSkus = state[field][parentIndex]?.seller_skus;
      if (sellerSkus && sellerSkus[childIndex]) {
        if (!sellerSkus[childIndex].po_sku_mappings_v2) {
          sellerSkus[childIndex].po_sku_mappings_v2 = {};
        }
        sellerSkus[childIndex].po_sku_mappings_v2.ship_quantity = value;
      }
    },
    updateWarehouseStock(state, { payload: { field, parentIndex, childIndex, value } }) {
      state[field][parentIndex]['seller_skus'][childIndex]['warehouse_stock'] = value;
    },
    populateHighlightState(state, { payload: { productIds } }) {
      state['poItems'].forEach(({ product }, index) => {
        let isHighlighted = false;
        if (productIds.some((product_id) => product_id === product?.id)) isHighlighted = true;
        state['poItems'][index]['isHighlighted'] = isHighlighted;
      });
    }
  },
  extraReducers: {
    [GetPoListing.pending]: (state) => {
      state.fetchingPos = true;
    },
    [GetPoListing.fulfilled]: (state, action) => {
      const { result, count, statusCounts } = action?.payload || {};

      state.fetchingPos = false;
      state.pos = result;
      state.totalPosCount = count;
      state.userPoAllStatusCount = statusCounts || {};
    },
    [GetPoListing.rejected]: (state) => {
      state.fetchingPos = false;
    },

    [GetPoItems.pending]: (state, action) => {
      const { exportAll } = action?.meta?.arg || {};
      if (!exportAll) {
        state.fetchingPoItems = true;
      }
      else state.exportingData = true;
    },
    [GetPoItems.fulfilled]: (state, action) => {
      const { result, count } = action?.payload || {};
      const { exportAll } = action?.meta?.arg || {};
      if (!exportAll) {
        state.fetchingPoItems = false;
        state.poItems = result;
        state.totalPoItemsCount = count;
      }
      else state.exportingData = false;

    },
    [GetPoItems.rejected]: (state, action) => {
      const { exportAll } = action?.meta?.arg || {};
      if (!exportAll) {
        state.fetchingPoItems = false;
      }
      else state.exportingData = true;
    },

    [GetPoDetails.pending]: (state) => {
      state.fetchingPoDetails = true;
    },
    [GetPoDetails.fulfilled]: (state, action) => {
      const { data } = action?.payload || {};

      state.fetchingPoDetails = false;
      state.poDetails = data || {};
    },
    [GetPoDetails.rejected]: (state) => {
      state.fetchingPoDetails = false;
    },

    [GetVendorsList.pending]: (state) => {
      state.fetchingVendorsList = true;
    },
    [GetVendorsList.fulfilled]: (state, action) => {
      const { data } = action?.payload || {};
      state.vendorsList =
        data?.map(({ name, id }) => ({ value: name, label: name, id })) || [];
      state.fetchingVendorsList = false;
    },
    [GetVendorsList.rejected]: (state) => {
      state.fetchingVendorsList = false;
    },

    [getWarehousePos.pending]: (state) => ({
      ...state,
      fetchingWarehousePos: true
    }),
    [getWarehousePos.fulfilled]: (state, action) => {
      const { data, count, statusCounts } = action?.payload || {};
      state.warehousePos = data;
      state.totalWarehousePosCount = count;
      state.fetchingWarehousePos = false;
      state.warehousePoAllStatusCount = statusCounts || {};
    },
    [getWarehousePos.rejected]: (state) => {
      state.fetchingWarehousePos = false;
    },

    [getPoUsers.pending]: (state) => {
      state.fetchingPoUsers = true;
    },
    [getPoUsers.fulfilled]: (state, action) => {
      const { data } = action?.payload || {};
      state.poUsers =
        data?.map((user) => ({ value: user.id, label: user.name })) || [];
      state.fetchingPoUsers = false;
    },
    [getPoUsers.rejected]: (state) => {
      state.fetchingPoUsers = false;
    },

    [getWarehousePoDetails.pending]: (state) => {
      state.fetchingWarehousePoDetails = true;
    },
    [getWarehousePoDetails.fulfilled]: (state, action) => {
      const {
        data,
        totalInvoiceQuantity,
        totalOrderQuantity,
        totalReceivedQuantity,
        po_value,
        count,
        po_name,
        status,
        totalSkus
      } = action?.payload || {};
      state.poWarehouseDetails = data;
      state.totalWarehousePoDetailsCount = count;
      state.totalOrderQuantity = totalOrderQuantity;
      state.totalInvoiceQuantity = totalInvoiceQuantity;
      state.totalReceivedQuantity = totalReceivedQuantity;
      state.totalPoValue = po_value;
      state.totalPoValue = po_value;
      state.po_name = po_name;
      state.po_status = status;
      state.totalSkus = totalSkus;
      state.fetchingWarehousePoDetails = false;
    },
    [getWarehousePoDetails.rejected]: (state) => {
      state.fetchingWarehousePoDetails = false;
    },

    [EditPoItem.pending]: (state) => {
      state.updatingPoItem = true;
    },
    [EditPoItem.fulfilled]: (state, action) => {
      const { message, success } = action?.payload || {};

      state.updatingPoItem = false;
      notification[success ? 'success' : 'error']({
        message,
        top: 65
      });
    },
    [EditPoItem.rejected]: (state) => {
      state.updatingPoItem = false;
    },

    [GetProductsList.pending]: (state) => {
      state.fetchingProductsList = true;
    },
    [GetProductsList.fulfilled]: (state, action) => {
      const { data } = action?.payload || {};

      state.fetchingProductsList = false;
      state.productsList = data;
    },
    [GetProductsList.rejected]: (state) => {
      state.fetchingProductsList = false;
    },

    [AddPoItems.pending]: (state) => {
      state.addingPoItems = true;
    },
    [AddPoItems.fulfilled]: (state, action) => {
      const { message, success } = action?.payload || {};

      state.addingPoItems = false;
      notification[success ? 'success' : 'error']({
        message,
        top: 65
      });
    },
    [AddPoItems.rejected]: (state) => {
      state.addingPoItems = false;
    },

    [GetPoSkusList.pending]: (state) => {
      state.fetchingPoSkusList = true;
    },
    [GetPoSkusList.fulfilled]: (state, action) => {
      const { data, count, saveData } = action?.payload?.data || {};
      const previousList = [...state.poSkusList];

      const deletedIds =
        previousList?.filter((item) => item.deleted).map((item) => item.id) ||
        [];
      const updatedData = data.map((item) => ({
        ...item,
        deleted: deletedIds.includes(item.id) ? true : item.deleted
      }));

      state.poSkusList = !saveData
        ? [...updatedData]
        : [...previousList, ...data];
      state.fetchingPoSkusList = false;
      state.totalSkusListCount = count;
    },
    [GetPoSkusList.rejected]: (state) => {
      state.fetchingPoSkusList = false;
    },

    [DeletePoItem.pending]: (state) => {
      state.deletingPoItem = true;
    },
    [DeletePoItem.fulfilled]: (state, action) => {
      const { message, success } = action?.payload || {};

      state.deletingPoItem = false;
      notification[success ? 'success' : 'error']({
        message,
        top: 65
      });
    },
    [DeletePoItem.rejected]: (state) => {
      state.deletingPoItem = false;
    },

    [DeleteBulkPoItem.pending]: (state) => {
      state.deletingPoItem = true;
    },
    [DeleteBulkPoItem.fulfilled]: (state, action) => {
      const { message, success } = action?.payload || {};

      state.deletingPoItem = false;
      notification[success ? 'success' : 'error']({
        message,
        top: 65
      });
    },
    [DeleteBulkPoItem.rejected]: (state) => {
      state.deletingPoItem = false;
    },

    [CreatePo.pending]: (state) => {
      state.creatingPo = true;
    },
    [CreatePo.fulfilled]: (state, action) => {
      const { message, success, data, statusCounts } = action?.payload || {};

      state.userPoAllStatusCount = statusCounts || {};
      state.creatingPo = false;
      notification[success ? 'success' : 'error']({
        message,
        top: 65
      });

      if (success) {
        state.pos.unshift(data);
        state.totalPosCount = state.totalPosCount + 1;
      }
    },
    [CreatePo.rejected]: (state) => {
      state.creatingPo = false;
    },

    [MapPoAndSkus.pending]: (state) => {
      state.mappingPoAndSkus = true;
    },
    [MapPoAndSkus.fulfilled]: (state, action) => {
      const { message, success } = action?.payload || {};

      state.mappingPoAndSkus = false;
      notification[success ? 'success' : 'error']({
        message,
        top: 65
      });
    },
    [MapPoAndSkus.rejected]: (state) => {
      state.mappingPoAndSkus = false;
    },

    [ConfirmPo.pending]: (state) => {
      state.confirmingPo = true;
    },
    [ConfirmPo.fulfilled]: (state, action) => {
      const { message, success } = action?.payload || {};

      state.confirmingPo = false;
      notification[success ? 'success' : 'error']({
        message,
        top: 65
      });

      state.poDetails.status = 'confirmed';
    },
    [ConfirmPo.rejected]: (state) => {
      state.confirmingPo = false;
    },

    [StorePoSkusMapping.pending]: (state) => {
      state.uploadingPoSkusMapping = true;
    },
    [StorePoSkusMapping.fulfilled]: (state, action) => {
      const { message, success } = action?.payload || {};

      state.uploadingPoSkusMapping = false;
      notification[success ? 'success' : 'error']({
        message,
        top: 65
      });
    },
    [StorePoSkusMapping.rejected]: (state) => {
      state.uploadingPoSkusMapping = false;
    },

    [DeletePoSkuMapping.pending]: (state, action) => {
      state.deletingMappingPoAndSku = true;
    },
    [DeletePoSkuMapping.fulfilled]: (state, action) => {
      const { message, success } = action?.payload || {};
      state.deletingMappingPoAndSku = false;
      notification[success ? 'success' : 'error']({
        message,
        top: 65
      });
    },
    [DeletePoSkuMapping.rejected]: (state) => {
      state.deletingMappingPoAndSku = false;
    },

    [UpdatePoItemsFile.pending]: (state) => {
      state.uploadingPoItemsFile = true;
    },
    [UpdatePoItemsFile.fulfilled]: (state, action) => {
      const { message, success } = action?.payload || {};

      state.uploadingPoItemsFile = false;
      notification[success ? 'success' : 'error']({
        message,
        top: 65
      });
    },
    [UpdatePoItemsFile.rejected]: (state) => {
      state.uploadingPoItemsFile = false;
    },

    [StorePoFile.pending]: (state) => ({
      ...state,
      loading: true
    }),
    [StorePoFile.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.success = true;
      state.message = payload.message;
    },
    [StorePoFile.rejected]: (state, { payload }) => ({
      ...state,
      err: payload.error?.error || payload.error,
      loading: false
    }),
    [GetWarehousePoHistory.pending]: (state) => {
      state.fetchingWarehousePoHistory = true;
    },
    [GetWarehousePoHistory.fulfilled]: (state, action) => {
      const { data } = action?.payload || {};

      state.fetchingWarehousePoHistory = false;
      state.warehousePoHistory = data;
    },
    [GetWarehousePoHistory.rejected]: (state) => {
      state.fetchingWarehousePoHistory = false;
    },
    [UpdatePo.pending]: (state) => {
      state.updatePoLoading = true;
    },
    [UpdatePo.fulfilled]: (state, action) => {
      const { message, success } = action?.payload || {};

      state.updatePoLoading = false;
      notification[success ? 'success' : 'error']({
        message,
        top: 65
      });
    },
    [UpdatePo.rejected]: (state) => {
      state.updatePoLoading = false;
    },
    [ScanProduct.pending]: (state) => {
      state.scanProductLoading = true;
    },
    [ScanProduct.fulfilled]: (state, action) => {
      const { data } = action?.payload || {};
      state.scanProductLoading = false;
      state.scannedProduct = data;
    },
    [ScanProduct.rejected]: (state) => {
      state.scanProductLoading = false;
    },
    [CreateReceiveHistory.pending]: (state) => {
      state.createReceivingLoading = true;
    },
    [CreateReceiveHistory.fulfilled]: (state, action) => {
      state.createReceivingLoading = false;
    },
    [CreateReceiveHistory.rejected]: (state) => {
      state.createReceivingLoading = false;
    },
    [DeleteReceivedHistory.pending]: (state) => {
      state.deleteReceivingLoading = true;
    },
    [DeleteReceivedHistory.fulfilled]: (state, action) => {
      state.deleteReceivingLoading = false;
    },
    [DeleteReceivedHistory.rejected]: (state) => {
      state.deleteReceivingLoading = false;
    },
    [DeletePo.pending]: (state) => {
      state.deletingPo = true;
    },
    [DeletePo.fulfilled]: (state, action) => {
      const { message, success } = action?.payload || {};

      state.deletingPo = false;
      notification[success ? 'success' : 'error']({
        message,
        top: 65
      });

      state.poDetails.status = 'confirmed';
    },
    [DeletePo.rejected]: (state) => {
      state.deletingPo = false;
    },

    [GetErroredItems.pending]: (state) => {
      state.fetchingErroredItems = true;
    },
    [GetErroredItems.fulfilled]: (state, action) => {
      const { count, data } = action?.payload || {};

      state.erroredItems = data;
      state.erroredItemsTotalCount = count;
      state.fetchingErroredItems = false;
    },
    [GetErroredItems.rejected]: (state) => {
      state.fetchingErroredItems = false;
    },
    [getAllFileUploadHistory.pending]: (state) => {
      state.fetchingAllFileUploadHistory = true;
    },
    [getAllFileUploadHistory.fulfilled]: (state) => {
      state.fetchingAllFileUploadHistory = false;
    },
    [getAllFileUploadHistory.rejected]: (state) => {
      state.fetchingAllFileUploadHistory = false;
    },
    [getLatestFileUpload.pending]: (state) => {
      state.fetchingLatestFileUpload = true;
    },
    [getLatestFileUpload.fulfilled]: (state) => {
      state.fetchingLatestFileUpload = false;
    },
    [getLatestFileUpload.rejected]: (state) => {
      state.fetchingLatestFileUpload = false;
    },
    [BulkReceive.pending]: (state) => {
      state.bulkReceivingLoading = true;
    },
    [BulkReceive.fulfilled]: (state, action) => {
      const { message, success } = action?.payload || {};

      state.bulkReceivingLoading = false;
      notification[success ? 'success' : 'error']({
        message,
        top: 65
      });
    },
    [BulkReceive.rejected]: (state) => {
      state.bulkReceivingLoading = false;
    },
    [ExportFilteredPoItems.pending]: (state) => {
      state.exportingData = true;
    },
    [ExportFilteredPoItems.fulfilled]: (state) => {
      state.exportingData = false;
    },
    [ExportFilteredPoItems.rejected]: (state) => {
      state.exportingData = false;
    },
    [ExportAsinData.pending]: (state) => {
      state.exportingData = true;
    },
    [ExportAsinData.fulfilled]: (state) => {
      state.exportingData = false;
    },
    [ExportAsinData.rejected]: (state) => {
      state.exportingData = false;
    }
  }
});

const { reducer, actions } = pos;

export const { setField, SetPoState, clearField, softDeleteEntry, updateSoftDeleteStatus, updateShipQty, updatePOShipQty, updateWarehouseStock, populateHighlightState } = actions;

export default reducer;
